import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobTrackingEntries/table${`?query=${string}&startDate=${string}&endDate=${string}&cursor=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobTrackingEntries/table`;

/**
 * @param startDate YYYY-MM-DD
 * @param endDate YYYY-MM-DD
 */
export const URL = (jobId: number, tableQuery: TableQuery, startDate: string, endDate: string, cursor: string): RouteDefinition =>
	`${baseRoute}/${jobId}/jobTrackingEntries/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&startDate=${startDate}&endDate=${endDate}&cursor=${cursor}`;
